import Typography from "@mui/material/Typography";
import React from "react";
import { TicketErrorHelper } from "../../../Utils/TicketErrorHelper";
import { MenuCardContent, ValidationResult } from "../../../Utils/Interfaces";
import TimeCalculator from "../../../sharedCode/TimeCalculator";
import { optionalEss } from "../../../Utils/UtilityMethods";
import { TicketExtended } from "../../../Utils/TypeExtensions";

export default function FlightLegsMenuContent(ticket: TicketExtended, title: string, validationResults: ValidationResult[]): MenuCardContent {
    const prettyHours = TimeCalculator.getTotalFlightTimeFormatted(ticket);
    const hoursValue = TimeCalculator.getTotalFlightTime(ticket).toNumber();

    const details = (
        <>
            <Typography textAlign={"center"}>
                {ticket?.Locations?.length ?? 0} LEG{optionalEss(ticket?.Locations?.length ?? 0)}
            </Typography>
            <Typography textAlign={"center"}>
                {prettyHours} FLIGHT HOUR{optionalEss(hoursValue)}
            </Typography>
        </>
    );

    const validationMessages = TicketErrorHelper.getCardErrors(validationResults, title);

    return { details, validationMessages };
}
